import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import styles from './Demo.module.css';
import demoVideo from '../../asset/demo/demo-healthcare.mp4';
import demoThumbnail from '../../asset/psshealthimg.jpg';
import Navbar from '../navbar/Navbar';
import ContactUs from '../contact/ContactUs';
import Footer from '../footer/Footer';

const Demo = () => {
  return (
    /* Change 1: demoPageWrapper ensures a standard top-to-bottom flow */
    <div className={styles.demoPageWrapper}>
      <Navbar />
      
      {/* Change 2: This section handles the centered video content */}
      <section className={styles.demoSection}>
        <div className={styles.container}>
          <Typography variant="h2" className={styles.mainTitle}>
            See Healthcare Ai bot in Action
          </Typography>

          <div className={styles.videoWrapper}>
            <div className={styles.videoFrame}>
              <video 
                controls 
                poster={demoThumbnail} 
                className={styles.videoPlayer}
              >
                <source src={demoVideo} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          </div>

          <Typography className={styles.tagline}>
            “Scaling your content has never been this intelligent.”
          </Typography>

          <Box className={styles.buttonWrapper}>
            <Button 
              variant="contained" 
              className={styles.generateButton}
              onClick={() => window.location.href = '/'}
            >
              Go to Home
            </Button>
          </Box>
        </div>
      </section>

      <ContactUs />
      <Footer />
    </div>
  );
};

export default Demo;